export const uploadsActionTypes={
SET_UPLOADS:"SET_UPLOADS"
}